import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ICase } from '@features/cases/interfaces/cases.interface';
import { SkinsListComponent } from '../../../core/components/skins-list/skins-list.component';
import { BalanceType } from '@core/types/balance.type';
import { CostComponent } from '../../../core/components/cost/cost.component';
@Component({
  selector: 'app-cb-case-skins-modal',
  imports: [SkinsListComponent, CostComponent],
  templateUrl: './cb-case-skins-modal.component.html',
  styleUrl: './cb-case-skins-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class CaseBattlesCaseSkinsModalComponent {
  caseItem = input.required<ICase>();
  balance = input.required<BalanceType>();
  showPrice = input<boolean>(true);
  responsiveImage = input<boolean>(false);
}
